module.exports = jwcomps;